export var TokenErrorStatus = /*#__PURE__*/ function(TokenErrorStatus) {
    TokenErrorStatus["Expired"] = "expired";
    TokenErrorStatus["Invalid"] = "invalid";
    TokenErrorStatus["AlreadyCompleted"] = "alreadyCompleted";
    // Token valid but a downstream step failed — link is still usable, so retry not invalid.
    TokenErrorStatus["Retry"] = "retry";
    return TokenErrorStatus;
}({});
